module.exports = __webpack_public_path__ + "img/dropdown.dfff45ff.svg";